import CustomHTMLElement from './../../../elements/customHTMLElement';

export default class ListItem extends CustomHTMLElement {
	constructor(properties = {}) {
		super();
		this.setProperties(properties);
		this._createPropertyMethods();
		
		this._template = require('./templates/listItem.handlebars');
	}
}